var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      class: { "border-blue": _vm.lead.status_id === 9 },
      attrs: { id: _vm.lead.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("leads.show") || _vm.$_can("leads.view-own")
        }
      }
    },
    [
      _vm.leadLoading
        ? [_vm._m(0)]
        : [
            _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "LeadsEdit",
                    params: { id: "" + _vm.lead.id },
                    query: {
                      q:
                        "" +
                        (_vm.q
                          ? "" + encodeURIComponent(_vm.q.toUpperCase())
                          : "")
                    }
                  }
                }
              },
              [
                _c("div", { staticClass: "d-flex list-box-header col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pl-0 list-box-header-left col-lg-7 col-9 pr-md-5 pr-lg-5 pr-xl-5"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pl-0 d-flex align-items-center col-lg-5 col-md-5 col-xl-5 col-12 pointer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-box-status align-items-start col-lg-5 col-md-5 col-xl-5 col-12 pr-3",
                              on: {
                                mousemove: function($event) {
                                  _vm.visible = true
                                },
                                mouseleave: function($event) {
                                  _vm.visible = false
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "pointer d-flex" }, [
                                _c("span", { staticClass: "ref-id pr-2" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.lead.ref_id) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm.visible
                                    ? _c("i", {
                                        staticClass:
                                          "fa fa-copy list-box-icon pointer",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            _vm.copyToClipboard(
                                              _vm.lead.ref_id,
                                              "Successfully copied to clipboard"
                                            )
                                          },
                                          mousemove: function($event) {
                                            _vm.visible = true
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.lead.status
                                ? [
                                    _vm.lead.status_id === 1
                                      ? _c(
                                          "span",
                                          { class: "btn-status btn-active" },
                                          [_vm._v(_vm._s(_vm.lead.status))]
                                        )
                                      : _vm.lead.status_id === 2
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-booked" },
                                            [_vm._v(_vm._s(_vm.lead.status))]
                                          )
                                        : _vm.lead.status_id === 3 ||
                                          _vm.lead.status_id === 6
                                          ? _c(
                                              "span",
                                              {
                                                class: "btn-status btn-closed"
                                              },
                                              [_vm._v(_vm._s(_vm.lead.status))]
                                            )
                                          : _vm.lead.status_id === 4 ||
                                            _vm.lead.status_id === 8
                                            ? _c(
                                                "span",
                                                {
                                                  class: "btn-status btn-ncover"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.lead.status)
                                                  )
                                                ]
                                              )
                                            : _vm.lead.status_id === 5
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "btn-status btn-rtbook"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.lead.status)
                                                    )
                                                  ]
                                                )
                                              : _vm.lead.status_id === 7
                                                ? _c(
                                                    "span",
                                                    {
                                                      class:
                                                        "btn-status btn-rejected"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.lead.status)
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      class:
                                                        "btn-status btn-active"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.lead.status)
                                                      )
                                                    ]
                                                  )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "claim-customer col-7 pl-3 d-none d-md-flex d-lg-flex d-xl-flex"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.customer.name) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-3 wrap pointer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "claim-moving-company contact-info-wrap"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.company) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("label"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center claim-move-date contact-info-wrap col-2 wrap pointer"
                        },
                        [
                          _c("customTooltip", {
                            attrs: { config: { placement: "top" } },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var isOpen = ref.isOpen
                                  var open = ref.open
                                  var close = ref.close
                                  return _c(
                                    "div",
                                    {
                                      on: { mouseover: open, mouseleave: close }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-trigger": "" } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.lead.move_date) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: isOpen,
                                              expression: "isOpen"
                                            }
                                          ],
                                          staticClass: "custom-tooltip",
                                          attrs: { "data-popper": "" }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "border-black",
                                            attrs: { "x-arrow": "" }
                                          }),
                                          _vm._v(
                                            "\n                  Move date\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-3 pr-4 wrap pointer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "claim-move-date contact-info-wrap"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.move_size) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-box-header-right col-lg-5 col-3 pl-md-5 pl-lg-5 pl-xl-5"
                    },
                    [
                      _c("label"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-0 col-lg-5 wrap pointer"
                        },
                        [
                          _c("customTooltip", {
                            attrs: { config: { placement: "top" } },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var isOpen = ref.isOpen
                                  var open = ref.open
                                  var close = ref.close
                                  return _c(
                                    "div",
                                    {
                                      on: { mouseover: open, mouseleave: close }
                                    },
                                    [
                                      _vm.lead.cluster_user
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "claim-agent",
                                              attrs: { "data-trigger": "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.lead.cluster_user
                                                      .username
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "claim-agent",
                                              attrs: { "data-trigger": "" }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-exclamation-circle unassigned-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                    Unassigned\n                  "
                                                )
                                              ])
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: isOpen,
                                              expression: "isOpen"
                                            }
                                          ],
                                          staticClass: "custom-tooltip",
                                          attrs: { "data-popper": "" }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "border-black",
                                            attrs: { "x-arrow": "" }
                                          }),
                                          _vm._v(
                                            "\n                  Assignee\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-box-header-options justify-content-end col-12 col-lg-7"
                        },
                        [
                          _vm.lead.status_id === 2
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "claim-trucks-movers d-none d-md-flex d-lg-flex d-xl-flex align-items-center pr-4 wrap pointer"
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-user list-box-icon"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "price-value pr-2" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.lead.movers) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-truck list-box-icon"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "price-value" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.lead.trucks) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lead.status_id === 2
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center price pr-md-5 pr-lg-5 pr-xl-5 wrap pointer"
                                },
                                [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(_vm.lead.price_per_hour) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "options pr-2 pr-md-0 pr-lg-0 pr-xl-0 pl-md-4 pl-lg-4 pl-xl-4"
                            },
                            [
                              _c("div", { staticClass: "options-buttons" }, [
                                _vm.lead.status_id !== 3 &&
                                _vm.lead.status_id !== 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "dropdown",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                          }
                                        }
                                      },
                                      [
                                        _c("button", {
                                          staticClass:
                                            "btn btn-secondary add-filter",
                                          attrs: {
                                            type: "button",
                                            id: "dropdownMenuButton",
                                            "data-toggle": "dropdown",
                                            "aria-haspopup": "true",
                                            "aria-expanded": "false"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right",
                                            attrs: {
                                              "aria-labelledby":
                                                "dropdownMenuButton"
                                            }
                                          },
                                          [
                                            _vm.$_can("leads.assign")
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item nav-link btn",
                                                    on: {
                                                      click: _vm.reassignModal
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Reassign lead\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id === 1 ||
                                            _vm.lead.status_id === 7
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item nav-link btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          5
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Ready for booking\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id !== 7
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item nav-link btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          7
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      On hold\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id !== 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item nav-link btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          3
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Close lead\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.lead.status_id !== 8
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "dropdown-item nav-link btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.changeStatus(
                                                          _vm.lead.id,
                                                          8
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      No availability\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-secondary expand-claims d-none d-md-block d-lg-block d-xl-block",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        _vm.toggleLead(_vm.lead.id)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-caret-down caret",
                                      class: {
                                        rotate: _vm.expanded.includes(
                                          _vm.lead.id
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              class: [
                _vm.expanded.includes(_vm.lead.id) ? "w-100 divider" : "hidden"
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column",
                class: [
                  _vm.expanded.includes(_vm.lead.id)
                    ? "list-box-expanded"
                    : "hidden"
                ]
              },
              [
                _c("div", { staticClass: "d-flex row col-12 p-0" }, [
                  _vm.showCustomerInfo
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-md-flex d-lg-flex d-xl-flex flex-column justify-content-start col-lg-3 col-1 customer-info-wrap"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "contact-info mb-4 contact-info-wrap"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "claim-heading pb-3" },
                                [
                                  _vm._v(
                                    "\n              Contact info\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "email" }, [
                                _c("i", {
                                  staticClass: "fa fa-at list-box-icon"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.lead.customer.email) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "phone" }, [
                                _c("i", {
                                  staticClass: "fa fa-phone list-box-icon"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.phoneMask.maskedPhone(
                                        _vm.lead.customer.phone
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.$_can("leads.follow-ups.store")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row py-2 mx-0 follows-buttons follows-buttons-list"
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "mod-icon-btn-follow mod-icon-btn-incall pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.showCallModal = true
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "mod-icon-btn-follow mod-icon-btn-email pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.showEmailModal = true
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.lead.has_follow_up_number
                                    ? _c("span", {
                                        staticClass:
                                          "mod-icon-btn-follow mod-icon-btn-message pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.showSMSModal = true
                                          }
                                        }
                                      })
                                    : _c("customTooltip", {
                                        attrs: { config: { placement: "top" } },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var isOpen = ref.isOpen
                                              var open = ref.open
                                              var close = ref.close
                                              return _c(
                                                "div",
                                                {
                                                  on: {
                                                    mouseover: open,
                                                    mouseleave: close
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "mod-icon-btn-follow mod-icon-btn-message pointer disabled",
                                                    attrs: {
                                                      "data-trigger": ""
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: isOpen,
                                                          expression: "isOpen"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "custom-tooltip",
                                                      attrs: {
                                                        "data-popper": ""
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "border-black",
                                                        attrs: { "x-arrow": "" }
                                                      }),
                                                      _vm._v(
                                                        "\n                  Company doesn't have phone\n                  "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                  number for sending SMS\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          }
                                        ])
                                      }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "mod-icon-btn-follow mod-icon-btn-voice-call pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.showVoiceModal = true
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start col-lg-3 col-md-3 col-xl-3 col-12"
                    },
                    [
                      _c("span", { staticClass: "claim-heading" }, [
                        _vm._v("\n            From - To\n          ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "circles-wrap" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column justify-content-between mt-3"
                          },
                          [
                            _c("div", { staticClass: "d-flex mb-4" }, [
                              _c("i", {
                                staticClass: "fa fa-circle c-pickup",
                                class: [
                                  _vm.lead.addresses[0].type.name === "Pickup"
                                    ? "c-pickup"
                                    : "c-delivery",
                                  _vm.lead.addresses[0].apartment ||
                                  _vm.lead.addresses[0].floor
                                    ? "fa-circle-with-apt"
                                    : "fa-circle"
                                ]
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "d-flex flex-column address-text"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.lead.addresses[0].full_address
                                      ) +
                                      "\n                  "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pt-3"
                                    },
                                    [
                                      _c("span", { staticClass: "apt-floor" }, [
                                        _vm._v(
                                          "Apt: " +
                                            _vm._s(
                                              _vm.lead.addresses[0].apartment
                                                ? _vm.lead.addresses[0]
                                                    .apartment
                                                : "-"
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "apt-floor pl-4" },
                                        [
                                          _vm._v(
                                            "Floor: " +
                                              _vm._s(
                                                _vm.lead.addresses[0].floor
                                                  ? _vm.lead.addresses[0].floor
                                                  : "-"
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.lead.addresses.length > 2
                          ? _c("span", { staticClass: "remaining-addresses" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    parseInt(_vm.lead.addresses.length) - 2
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column justify-content-between mt-3"
                          },
                          [
                            _c("div", { staticClass: "d-flex mb-4" }, [
                              _c("i", {
                                staticClass: "fa fa-circle c-pickup",
                                class: [
                                  _vm.lead.addresses[
                                    _vm.lead.addresses.length - 1
                                  ].type.name === "Pickup"
                                    ? "c-pickup"
                                    : "c-delivery",
                                  _vm.lead.addresses[
                                    _vm.lead.addresses.length - 1
                                  ].apartment ||
                                  _vm.lead.addresses[
                                    _vm.lead.addresses.length - 1
                                  ].floor
                                    ? "fa-circle-with-apt"
                                    : "fa-circle"
                                ]
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "d-flex flex-column address-text"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.lead.addresses[
                                          _vm.lead.addresses.length - 1
                                        ].full_address
                                      ) +
                                      "\n                  "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center pt-3"
                                    },
                                    [
                                      _c("span", { staticClass: "apt-floor" }, [
                                        _vm._v(
                                          "Apt: " +
                                            _vm._s(
                                              _vm.lead.addresses[
                                                _vm.lead.addresses.length - 1
                                              ].apartment
                                                ? _vm.lead.addresses[
                                                    _vm.lead.addresses.length -
                                                      1
                                                  ].apartment
                                                : "-"
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "apt-floor pl-4" },
                                        [
                                          _vm._v(
                                            "Floor: " +
                                              _vm._s(
                                                _vm.lead.addresses[
                                                  _vm.lead.addresses.length - 1
                                                ].floor
                                                  ? _vm.lead.addresses[
                                                      _vm.lead.addresses
                                                        .length - 1
                                                    ].floor
                                                  : "-"
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start col-lg-2 contact-info-wrap"
                    },
                    [
                      _c("div", { staticClass: "list-box-info mb-4" }, [
                        _c("span", { staticClass: "claim-heading pb-3" }, [
                          _vm._v("\n              Deposit\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.lead.deposit_unit === "$"
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.deposit_unit) +
                                  _vm._s(_vm.lead.deposit_value) +
                                  "\n            "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.deposit_value) +
                                  " " +
                                  _vm._s(_vm.lead.deposit_unit) +
                                  "\n            "
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-box-info mb-4" }, [
                        _c("span", { staticClass: "claim-heading pb-3" }, [
                          _vm._v("\n              Tags\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.$_can("tags.show")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-start flex-wrap"
                              },
                              _vm._l(_vm.lead.tags, function(tag) {
                                return _c("tag-color", {
                                  key: tag.id,
                                  attrs: {
                                    color: tag.color.name,
                                    name: tag.name,
                                    "input-class": "mr-1"
                                  }
                                })
                              })
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column justify-content-start col-lg-2 col-md-2 col-xl-2 col-12"
                    },
                    [
                      _c("div", { staticClass: "list-box-info mb-4" }, [
                        _c("span", { staticClass: "claim-heading pb-3" }, [
                          _vm._v("\n              Created by\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.lead.status_id !== 9 && _vm.lead.cluster_user
                          ? _c("span", { staticClass: "pb-3" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.cluster_user.username) +
                                  "\n            "
                              )
                            ])
                          : _c("span", { staticClass: "pb-3" }, [
                              _vm._v("\n              System\n            ")
                            ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "claim-heading pb-3" }, [
                          _vm._v("\n              Arrival window\n            ")
                        ]),
                        _vm._v(" "),
                        _vm.lead.arrival_window_from ||
                        _vm.lead.arrival_window_to
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.lead.arrival_window_from) +
                                  " - " +
                                  _vm._s(_vm.lead.arrival_window_to) +
                                  "\n            "
                              )
                            ])
                          : _c("span", [
                              _vm._v("\n              -\n            ")
                            ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-none d-md-flex d-lg-flex d-xl-flex flex-column justify-content-start col-lg-2 col-3"
                    },
                    [
                      _c("div", { staticClass: "list-box-info mb-4" }, [
                        _c(
                          "span",
                          {
                            staticClass: "claim-heading pb-3 contact-info-wrap"
                          },
                          [_vm._v("\n              Created at\n            ")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "pb-3 contact-info-wrap" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.lead.created_at) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "claim-heading pb-3" }, [
                          _vm._v("\n              Source\n            ")
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.lead.source) +
                              "\n            "
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.lead.status_id === 2
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-start col-12" },
                      [
                        _c(
                          "div",
                          { staticClass: "claim-closed col-lg-5 col-12" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "col-1 col-md-3 col-lg-3 col-xl-3",
                                attrs: {
                                  to: { path: "/jobs/edit/" + _vm.lead.job_id },
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex pointer justify-content-end go-to-job"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "reopen-text text-white d-none d-md-flex d-lg-flex d-xl-flex"
                                      },
                                      [_vm._v("Go to job")]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-arrow-right reopen-ico pl-2 text-white"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lead.follow_ups && _vm.lead.follow_ups.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "circles-wrap d-flex justify-content-start align-items-center col-12"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "follow-ups-title font-weight-bold pr-3"
                          },
                          [
                            _vm._v(
                              "\n          Completed follow ups:\n        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.lead.follow_ups, function(followUp, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "follow-ups-wrapper" },
                            [
                              followUp.type.id === 1
                                ? _c("div", {
                                    staticClass:
                                      "mod-icon-follow-up mod-icon-follow-incall"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              followUp.type.id === 2
                                ? _c("div", {
                                    staticClass:
                                      "mod-icon-follow-up mod-icon-follow-email"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              followUp.type.id === 3
                                ? _c("div", {
                                    staticClass:
                                      "mod-icon-follow-up mod-icon-follow-voice-call"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              followUp.type.id === 4
                                ? _c("div", {
                                    staticClass:
                                      "mod-icon-follow-up mod-icon-follow-message"
                                  })
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.showCallModal
              ? [
                  _c("call", {
                    attrs: { lead: _vm.lead },
                    on: { close: _vm.closeModal }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showEmailModal
              ? [
                  _c("email", {
                    attrs: { lead: _vm.lead, list: true },
                    on: { close: _vm.closeModal }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showSMSModal
              ? [
                  _c("s-m-s", {
                    attrs: { lead: _vm.lead, list: true },
                    on: { close: _vm.closeModal }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showVoiceModal
              ? [
                  _c("voice", {
                    attrs: { lead: _vm.lead },
                    on: { close: _vm.closeModal }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.showReassignModal
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": true },
                    on: {
                      close: function($event) {
                        _vm.showReassignModal = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _c("div", [
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.lead.ref_id) + " - Reassign lead to"
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Select User")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: { options: _vm.assignees },
                              on: {
                                change: function($event) {
                                  _vm.clearError($event)
                                }
                              },
                              model: {
                                value: _vm.assigneeId,
                                callback: function($$v) {
                                  _vm.assigneeId = $$v
                                },
                                expression: "assigneeId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cluster_user_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              attrs: { type: "button" },
                              on: { click: _vm.reassign }
                            },
                            [_vm._v("\n              Reassign\n            ")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis px-4 py-4" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-flex col-11 col-md-9 col-lg-9 col-xl-9 mb-2 p-0 pr-md-3 pr-lg-3 pr-xl-3 w-100 booked-lead"
      },
      [
        _c("i", { staticClass: "fa fa-check reopen-ico pr-2" }),
        _vm._v(" "),
        _c("p", [_vm._v("This lead was booked!")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-287ef7de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287ef7de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadsBlock.vue
// module id = null
// module chunks = 